import React from 'react';
import { Text } from 'react-native';

export const AcceptTerms = () => <Text>Your AcceptTerms</Text>;
